import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = {
  key: 0,
  class: "navbar"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "navbar-brand" }
const _hoisted_4 = ["alt"]
const _hoisted_5 = { class: "d-none d-sm-block" }
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.appWebview)
    ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: _ctx.$t('navbar_logo_alt_text'),
              height: "50",
              width: "150"
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("a", {
              class: "btn btn-outline-primary",
              href: _ctx.$t('navbar_right_button_link'),
              target: "_blank"
            }, _toDisplayString(_ctx.$t('navbar_right_button_text')), 9, _hoisted_6)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}